import { SectionLoader } from '@/components/shared';
import type { IAuthSignupFields } from '@/types';
import { Flex, Heading, Text } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';

interface IUserInfoBoxProps {
  isLoading: boolean;
  user?: IAuthSignupFields;
}

export const UserSettingsInfoBox = (props: IUserInfoBoxProps): JSX.Element => {
  const { t } = useTranslation();
  const { isLoading, user } = props;

  if (isLoading) return <SectionLoader />;

  return (
    <Flex justifyContent="space-between">
      <Flex direction="column">
        <Heading fontSize="h3.md" fontWeight="bold" lineHeight="taller">
          {user?.firstName} {user?.lastName}
        </Heading>
        <Flex gap={2}>
          <Text fontWeight="bold">{t('ACCOUNT.SETTINGS.FISCALCODE')} </Text>
          <Text>{user?.fiscalCode ?? user?.vatNumber}</Text>
        </Flex>
        <Flex gap={2}>
          <Text fontWeight="bold">{t('ACCOUNT.SETTINGS.EMAIL')}</Text> <Text>{user?.email}</Text>
        </Flex>
      </Flex>
    </Flex>
  );
};
